<template>
  <v-select :value="value" :items="items" :label="label" item-text="title" item-value="id" multiple
    @input="$emit('input', $event)">
    <template #prepend-item>
      <v-list-item dense @click.stop>
        <v-list-item-content class="py-1">
          <v-text-field v-model="newItemText" :placeholder="`Add new ${(label || 'item').toLowerCase()}`" dense
            hide-details color="amber" @click.stop @keydown.stop @keyup.enter.stop.prevent="addNew">
            <template #append>
              <v-btn icon small color="amber" :disabled="!newItemText.trim()" @click.stop="addNew">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mb-2" />
    </template>

    <template #no-data>
      <v-list-item dense>
        <v-list-item-content>
          <span class="text-caption grey--text">
            No {{ (label || 'items').toLowerCase() }} yet — type above to add the first one
          </span>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'OfferTaxonomySelect',

  props: {
    // v-model: array of selected item ids
    value: {
      type: Array,
      default: () => [],
    },
    // Available options: [{ id, title }, ...]
    items: {
      type: Array,
      default: () => [],
    },
    // Field label and the placeholder noun for the inline add input
    label: {
      type: String,
      default: '',
    },
    // Prefix used when minting ids for newly added entries
    idPrefix: {
      type: String,
      default: 'tax',
    },
  },

  data() {
    return {
      newItemText: '',
    }
  },

  methods: {
    addNew() {
      const text = this.newItemText.trim()
      if (!text) return

      // Case-insensitive dedupe against existing options
      const existing = this.items.find(
        (it) => (it.title || '').trim().toLowerCase() === text.toLowerCase()
      )
      if (existing) {
        if (!this.value.includes(existing.id)) {
          this.$emit('input', [...this.value, existing.id])
        }
        this.newItemText = ''
        return
      }

      const id = `${this.idPrefix}-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`
      const newItem = { id, title: text }

      this.$emit('update:items', [...this.items, newItem])
      this.$emit('input', [...this.value, id])

      this.newItemText = ''
    },
  },
}
</script>
